<template>
  <div
      class="content-block factory-block"
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-delay="100"
      id="factory"
  >
    <div class="block-left">
      <div class="block-number">02</div>
      <BlockHeader
          title="生产基地"
          subtitle="双核驱动，质造安心"
          subtitleEn="FACTORY INTRODUCTION"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="block-content">
        <div class="factory-headline">
          <h2 class="headline-main">双基地战略布局</h2>
          <p class="headline-sub">——宁波与舟山，协同发展新篇章——</p>
        </div>

        <div class="factories-comparison">
          <div class="factory-card">
            <div class="factory-card-header">
              <div class="factory-image-container">
                <img
                    :src="getImageUrl('gc1.png')"
                    alt="宁波工厂"
                    class="factory-image"
                    loading="lazy"
                >
                <div class="factory-image-glow"></div>
              </div>
              <h3 class="factory-card-title">
                宁波工厂——浙江丰隆食品加工有限公司
              </h3>
            </div>

            <div class="factory-card-content">
              <div class="factory-status">
                <span class="status-badge status-building">
                  <i class="fas fa-hard-hat"></i>
                  筑加工产能基底
                </span>
                <span class="status-text"></span>
              </div>

              <div class="factory-description">
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  浙江丰隆食品加工有限公司创办于2022年1月，公司位于浙江省宁波市江北区海川路，是一家专注肉制品研发生产的技术型企业。公司传承古法工艺，并结合现代化生产设备，生产以卤制系列牛肉干为主的休闲食品。
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  2022年起，丰隆工厂作为浙江老字号品牌"太丰"的自有工厂，基于独到的口味，过硬的品质，使古法卤牛肉干成为网红产品。除太丰外，丰隆工厂也为其他品牌提供代加工服务。
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  公司以严苛标准铸就品质基石，不仅先后荣获
                  BRCGS（通过合规实现品牌信誉全球标准）、HACCP（食品安全预防性控制体系）、ISO
                  22000（食品安全管理体系）三大国际权威认证，更跻身三星级绿色工厂行列。这不仅是对企业在食品安全全链条管控、关键风险精准预防及全球合规运营能力的高度认可，更彰显了丰隆食品以国际化标准为消费者守护每一份安心，用专业实力铸就值得信赖的食品品牌。
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  丰隆在注重品质的同时，更坚持研发创新。成立企业研发实验室，创建江北区丰隆微生物发酵和卤制工程技术中心，与浙江大学、宁波智能研究院等科研中心开展产学研合作，提升技术研发实力，申请了多个实用和发明专利，被评为国家高新技术企业、宁波市"专精特新"中小企业。
                </p>
              </div>

              <div class="factory-features">
                <div class="feature-item">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>宁波生产基地</span>
                </div>
                <div class="feature-item">
                  <i class="fas fa-expand-arrows-alt"></i>
                  <span>古法手艺</span>
                </div>
                <div class="feature-item">
                  <i class="fas fa-cogs"></i>
                  <span>综合基地</span>
                </div>
              </div>
            </div>
          </div>

          <div class="comparison-divider">
            <div class="divider-line"></div>
            <div class="divider-text">
              <i class="fas fa-sync-alt"></i>
              <span>双基地协同</span>
            </div>
            <div class="divider-line"></div>
          </div>

          <div class="factory-card">
            <div class="factory-card-header">
              <div class="factory-image-container">
                <img
                    :src="getImageUrl('gc3.png')"
                    alt="舟山工厂"
                    class="factory-image"
                    loading="lazy"
                >
                <div class="factory-image-glow"></div>
              </div>
              <h3 class="factory-card-title">
                舟山工厂——浙江太丰食品科技有限公司
              </h3>
            </div>

            <div class="factory-card-content">
              <div class="factory-status">
                <span class="status-badge status-planning">
                  <i class="fas fa-clipboard-check"></i>
                  布物流优势格局
                </span>
                <span class="status-text"></span>
              </div>

              <div class="factory-description">
                <p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  为深化食品产业链布局，集团于2023年成立浙江太丰食品科技有限公司，在舟山新建生产基地。
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  该项目充分发挥舟山港口优势与集团海外原料资源，工厂于2024年动工，占地4万㎡，总建筑面积约7万㎡，将进一步夯实太丰品牌的研发、生产与供应链实力，主要分为肉制品加工与销售、坚果生产与贸易两大板块：
                  <br />
                  一、肉制品加工与销售板块
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  以肉制品为重点发展方向，太丰食品科技公司将持续加大研发投入，构建从生产到销售的全链条管控体系，确保浙江老字号"太丰"系列牛肉干等产品在品质、口感与食品安全方面保持高度稳定性，实现"源头可溯、品质可控"。此外，生产基地将面向市场提供专业的OEM/ODM代加工服务，
                  未来计划为多家知名品牌客户提供涵盖产品研发、配方定制与规模化生产的一体化解决方案。
                  <br />
                  二、坚果生产与贸易板块
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  基于国内腰果约90%依赖越南进口的产业现状，太丰食品积极布局以腰果为核心的农产品全球供应链，在非洲建立直采渠道，并在舟山设立加工生产基地。通过"从源头到成品"的垂直整合模式，有效缩短中间环节，不仅为行业客户提供高性价比的优质腰果原料，也保障了面向终端消费者的产品新鲜度与卓越品质。
                </p>
                <p></p>
              </div>

              <div class="factory-features">
                <div class="feature-item">
                  <i class="fas fa-ship"></i>
                  <span>港口物流优势</span>
                </div>
                <div class="feature-item">
                  <i class="fas fa-robot"></i>
                  <span>国际先进产线</span>
                </div>
                <div class="feature-item">
                  <i class="fas fa-chart-line"></i>
                  <span>产能大幅提升</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="factory-stats">
          <div class="stat-item">
            <div class="stat-number">2<span class="stat-unit">个</span></div>
            <p class="stat-label">生产基地</p>
            <div class="stat-subtext">宁波+舟山</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">120<span class="stat-unit">+亩</span></div>
            <p class="stat-label">总面积</p>
            <div class="stat-subtext">双基地合计</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">↑<span class="stat-unit">300%</span></div>
            <p class="stat-label">总产能提升</p>
            <div class="stat-subtext">双基地投产后</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">∞</div>
            <p class="stat-label">协同效应</p>
            <div class="stat-subtext">1+1>2</div>
          </div>
        </div>
      </div>

      <div class="block-footer">
        <router-link :to="{ name: 'factory' }" class="block-btn">
          <span>工厂详情</span>
          <i class="fas fa-book-open"></i>
        </router-link>
      </div>
    </div>
  </div>

</template>

<script>
import BlockHeader from "../common/BlockHeader.vue";

export default {
  components: { BlockHeader },
  name: "FactoryBlock",
  methods: {
    getImageUrl(imageName) {
      return require(`@/assets/factory/${imageName}`);
    },
  }
};
</script>

<style scoped>
.factory-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.factory-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.factory-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.factory-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.factory-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.factory-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.factory-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.factory-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.factory-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.factory-block .block-content {
  margin-bottom: 25px;
}

.factory-block .factory-headline {
  margin-bottom: 30px;
  text-align: center;
  position: relative;
  padding-bottom: 20px;
}

.factory-block .factory-headline::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: 3px;
  background: linear-gradient(to right, transparent, #9a1b1e, transparent);
  border-radius: 2px;
}

.factory-block .headline-main {
  font-size: 2.2rem;
  font-weight: 700;
  color: #9a1b1e;
  margin-bottom: 8px;
  position: relative;
  display: inline-block;
}

.factory-block .headline-main::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 2px;
  background: #9a1b1e;
  border-radius: 1px;
}

.factory-block .headline-sub {
  font-size: 1rem;
  color: #666;
  letter-spacing: 2px;
  position: relative;
  padding: 0 20px;
  margin-top: 10px;
}

.factory-block .headline-sub::before,
.factory-block .headline-sub::after {
  content: "——";
  color: rgba(154, 27, 30, 0.4);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.factory-block .headline-sub::before {
  left: 0;
}

.factory-block .headline-sub::after {
  right: 0;
}

.factory-block .factories-comparison {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 30px;
  margin-bottom: 40px;
}

.factory-block .factory-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.03);
  transition: all 0.3s;
  position: relative;
}

.factory-block .factory-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.1);
  border-color: rgba(154, 27, 30, 0.2);
}

.factory-block .factory-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, #9a1b1e, #b22222);
}

.factory-block .factory-card:nth-child(1)::before {
  background: linear-gradient(to right, #2980b9, #3498db);
}

.factory-block .factory-card-header {
  padding: 15px;
  text-align: center;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.02), transparent);
  position: relative;
}

.factory-block .factory-card:nth-child(1) .factory-card-header {
  background: linear-gradient(135deg, rgba(41, 128, 185, 0.02), transparent);
}

.factory-block .factory-image-container {
  position: relative;
  width: 100%;
  height: 240px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 12px;
}

.factory-block .factory-image {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  border: 3px solid white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.factory-block .factory-image-container:hover .factory-image {
  transform: scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.factory-block .factory-card:nth-child(1) .factory-image {
  border: 3px solid rgba(41, 128, 185, 0.3);
}

.factory-block .factory-card:nth-child(3) .factory-image {
  border: 3px solid rgba(154, 27, 30, 0.3);
}

.factory-block .factory-image-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  background: radial-gradient(
      circle,
      rgba(154, 27, 30, 0.15) 0%,
      transparent 70%
  );
  filter: blur(15px);
  z-index: 1;
  opacity: 0.6;
  transition: all 0.3s ease;
}

.factory-block .factory-card:nth-child(1) .factory-image-glow {
  background: radial-gradient(
      circle,
      rgba(41, 128, 185, 0.15) 0%,
      transparent 70%
  );
}

.factory-block .factory-image-container:hover .factory-image-glow {
  opacity: 0.8;
  filter: blur(20px);
  width: 90%;
  height: 90%;
}

.factory-block .factory-card-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}

.factory-block .factory-card-location {
  font-size: 0.85rem;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 5px;
}

.factory-block .factory-card-location i {
  color: #9a1b1e;
  font-size: 0.9rem;
}

.factory-block .factory-card:nth-child(1) .factory-card-location i {
  color: #2980b9;
}

.factory-block .factory-card-content {
  padding: 0px 25px 25px;
}

.factory-block .factory-status {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.factory-block .status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  color: white;
}

.factory-block .status-building {
  background: linear-gradient(135deg, #2980b9, #3498db);
}

.factory-block .status-planning {
  background: linear-gradient(135deg, #9a1b1e, #b22222);
}

.factory-block .status-text {
  font-size: 0.9rem;
  color: #666;
}

.factory-block .factory-description {
  margin-bottom: 25px;
}

.factory-block .factory-description p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #444;
  margin-bottom: 15px;
}

.factory-block .factory-description p:last-child {
  margin-bottom: 0;
}

.factory-block .factory-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.factory-block .feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background: rgba(154, 27, 30, 0.03);
  border-radius: 8px;
  font-size: 0.85rem;
  color: #555;
  transition: all 0.3s;
}

.factory-block .factory-card:nth-child(1) .feature-item {
  background: rgba(41, 128, 185, 0.03);
}

.factory-block .feature-item:hover {
  background: rgba(154, 27, 30, 0.08);
  transform: translateY(-2px);
}

.factory-block .factory-card:nth-child(1) .feature-item:hover {
  background: rgba(41, 128, 185, 0.08);
}

.factory-block .feature-item i {
  color: #9a1b1e;
  font-size: 0.9rem;
}

.factory-block .factory-card:nth-child(1) .feature-item i {
  color: #2980b9;
}

.factory-block .comparison-divider {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.factory-block .divider-line {
  flex: 1;
  width: 2px;
  background: linear-gradient(to bottom, transparent, #9a1b1e, transparent);
  border-radius: 1px;
}

.factory-block .divider-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  background: white;
  border-radius: 30px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  color: #9a1b1e;
  font-size: 0.85rem;
  font-weight: 600;
}

.factory-block .divider-text i {
  font-size: 1rem;
  animation: rotate 4s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.factory-block .factory-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin: 40px 0;
}

.factory-block .stat-item {
  text-align: center;
  padding: 25px 20px;
  background: white;
  border-radius: 12px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.factory-block .stat-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(to right, #9a1b1e, #b22222);
}

.factory-block .stat-item:hover {
  background: rgba(154, 27, 30, 0.03);
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.1);
}

.factory-block .stat-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: #9a1b1e;
  margin-bottom: 8px;
  line-height: 1;
  position: relative;
}

.factory-block .stat-unit {
  font-size: 1rem;
  font-weight: 600;
  margin-left: 2px;
  color: rgba(154, 27, 30, 0.8);
}

.factory-block .stat-label {
  font-size: 0.9rem;
  color: #222;
  margin: 0 0 5px 0;
  font-weight: 600;
}

.factory-block .stat-subtext {
  font-size: 0.8rem;
  color: #888;
  margin: 0;
}

.factory-block .block-footer {
  display: flex;
  justify-content: flex-end;
}

.factory-block .block-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.factory-block .block-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
  );
  transition: left 0.5s;
}

.factory-block .block-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 12px 30px rgba(154, 27, 30, 0.3);
  color: white;
  text-decoration: none;
  background: linear-gradient(135deg, #b22222, #d32f2f);
}

.factory-block .block-btn:hover::before {
  left: 100%;
}

.factory-block .block-btn i {
  transition: transform 0.3s;
}

.factory-block .block-btn:hover i {
  transform: translateX(5px);
}

@media (max-width: 1200px) {
  .factory-block .block-left {
    flex: 0 0 250px;
  }

  .factory-block .factory-card-title {
    font-size: 1rem;
    padding: 0 5px;
  }
}

@media (max-width: 992px) {
  .factory-block {
    flex-direction: column;
  }

  .factory-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .factory-block .block-right {
    padding: 30px 25px;
  }

  .factory-block .factory-image-container {
    height: 220px;
  }
}

@media (max-width: 768px) {
  .factory-block .factories-comparison {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    gap: 20px;
  }

  .factory-block .comparison-divider {
    flex-direction: row;
    gap: 20px;
  }

  .factory-block .divider-line {
    width: 100%;
    height: 2px;
  }

  .factory-block .divider-text {
    flex-direction: row;
    gap: 8px;
  }

  .factory-block .factory-features {
    grid-template-columns: 1fr;
  }

  .factory-block .headline-main {
    font-size: 1.8rem;
  }

  .factory-block .headline-sub {
    font-size: 0.9rem;
  }

  .factory-block .factory-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .factory-block .stat-number {
    font-size: 1.8rem;
  }

  .factory-block .block-btn {
    width: 100%;
    justify-content: center;
  }

  .factory-block .factory-card-title {
    font-size: 1.05rem;
    white-space: normal;
    text-overflow: clip;
    line-height: 1.3;
  }

  .factory-block .factory-image-container {
    height: 200px;
  }
}

@media (max-width: 480px) {
  .factory-block .factory-stats {
    grid-template-columns: 1fr;
  }

  .factory-block .factory-card-title {
    font-size: 1rem;
  }

  .factory-block .factory-image-container {
    height: 180px;
  }
}

.factory-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
      circle,
      rgba(154, 27, 30, 0.03) 0%,
      transparent 70%
  );
  z-index: 0;
}

.factory-block > * {
  position: relative;
  z-index: 1;
}

.factory-block::before {
  content: "⚙";
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 1.5rem;
  color: rgba(154, 27, 30, 0.1);
  z-index: 0;
}
</style>